var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#09547e",
    height: 231,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0.0 0.0 231.0 231.0",
    width: 231,
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "change1_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.5,0C51.7,0,0,51.7,0,115.5c0,63.8,51.7,115.5,115.5,115.5c63.8,0,115.5-51.7,115.5-115.5C230.9,51.7,179.2,0,115.5,0z M182,147.8c-1.3,8.5-8.7,14.7-17.3,14.7h-51.3H66.2c-8.6,0-16-6.2-17.3-14.7c-1.2-7.9-2.4-18.9-2.5-32.4 c0.1-13.5,1.2-24.4,2.5-32.4c1.3-8.5,8.7-14.7,17.3-14.7h47.2h51.3c8.6,0,16,6.2,17.3,14.7c1.2,7.9,2.4,18.9,2.5,32.4 C184.4,128.9,183.2,139.9,182,147.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.9 96.7L100.9 134.2 135.8 115.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6598866ee209f06e38d098baf3b4c9a4.svg";
export { ForwardRef as ReactComponent };